"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var usePaginatedBulkQuery_1 = require("../usePaginatedBulkQuery/usePaginatedBulkQuery");
var getTrailingDependency = function (dependencies) {
    return dependencies[0];
};
var mergeDependencies = function (_, trailing) {
    return trailing.currentState.variant.result;
};
function usePaginatedQuery(_a) {
    var options = _a.options, rest = __rest(_a, ["options"]);
    var mappedOptions = __assign(__assign({}, options), { args: [options.args] });
    return usePaginatedBulkQuery_1.useInternalPaginatedBulkQuery(__assign({ getTrailingDependency: getTrailingDependency,
        mergeDependencies: mergeDependencies, options: mappedOptions }, rest));
}
exports.default = usePaginatedQuery;
//# sourceMappingURL=usePaginatedQuery.js.map